import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=273e37ca&scoped=true&"
import script from "./DetailView.vue?vue&type=script&lang=js&"
export * from "./DetailView.vue?vue&type=script&lang=js&"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=273e37ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e37ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273e37ca')) {
      api.createRecord('273e37ca', component.options)
    } else {
      api.reload('273e37ca', component.options)
    }
    module.hot.accept("./DetailView.vue?vue&type=template&id=273e37ca&scoped=true&", function () {
      api.rerender('273e37ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DetailView.vue"
export default component.exports